import logo from "./home page/logo.svg"
import HomeImg from "./home page/main-banner.jpg"
import BottomShapes from "./home page/shapes/Shapemainsection.svg"
import Network from "./home page/use cases/Networking Solutions.svg"
import EndUserComputing from "./home page/use cases/End User Computing.svg"
import WorkplaceSecurity from "./home page/use cases/Workplace Security.svg"
import ElectricSolutions from "./home page/use cases/Electric Vehicle Charging.svg" 
import Wifi from "./home page/use cases/Wifi And Internet Service.svg"
import  IndustrialIot from "./home page/use cases/Iot And Industrial Iot.svg"
import DataCenter from "./home page/use cases/Data Center Field Support.svg"
import Programmable from "./home page/use cases/Programmable Field.svg"
import GrowBusiness  from "./home page/grow your business/Grow your Business section.svg"
import ApproveRate from "./home page/how it works/Approve & Rate performance.svg"
import Collaborate from "./home page/how it works/Collaborate With field teams.svg"
import PayOnDemand from "./home page/how it works/pay on demand.svg"
import Track from "./home page/how it works/Track status.svg"
import BookRequest from "./home page/how it works/bookrequest.svg"
import Bannerwave  from "./home page/banner-wave-shape.svg"
import Footerwave  from "./home page/footer-wave-shape.svg"
import Commitment  from "./home page/commitment-to-serve.svg"
import Verification from "./other pages/verification.svg"
import Yourdetails  from "./other pages/your-details.svg"
import Payment from "./other pages/payment.svg"
import Enginerpic from "./enginerr-profile-pic.png"
import ticketimg from "./other pages/ticketimg.png"
import Google from "./Google.png"


const imgIcon = {
    logo,
    HomeImg,
    BottomShapes,
    Network,
    EndUserComputing,
    WorkplaceSecurity,
    ElectricSolutions,
    Wifi,
    IndustrialIot,
    DataCenter,
    Programmable,
    GrowBusiness,
    ApproveRate,
    Collaborate,
    PayOnDemand,
    BookRequest,
    Track,
    Bannerwave,
    Footerwave,
    Commitment,
    Verification,
    Yourdetails,
    Payment,
    Enginerpic,
    ticketimg,
    Google
}

export default imgIcon